__turbopack_context__.v({
  "className": "poppins_c326c440-module__2yDNPa__className",
});
